import { Directive, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormConstructorContent } from 'src/app/interfaces/form-and-field.interface';
import { FormConstructorDataStrategy, ModelData } from '../form-constructor-data.strategy';
import { FormConstructorBaseComponent } from './form-constructor-base/form-constructor-base.component';

@Directive()
export abstract class AbstractFormConstructorComponent implements OnInit {
  @Input({ required: true }) public formContent: FormConstructorContent;

  @ViewChild(FormConstructorBaseComponent, { static: false })
  public childForm: FormConstructorBaseComponent;

  public dataStrategy: FormConstructorDataStrategy;

  public ngOnInit(): void {
    this.setFormContentDataType();
  }

  public abstract prepareSubmitData(): void;

  protected getFormValues(form: UntypedFormGroup): void {
    this.formContent = this.dataStrategy.getFormValues(form, this.formContent);
  }

  private setFormContentDataType(): void {
    this.dataStrategy = new ModelData();
  }
}
